export const Sections = {
  SESSION_NOTE: 'session-note',
  TREATMENT_PLAN: 'treatment-plan',
  BILLING_REQUIREMENTS: 'billing-requiremments',
  FEEDBACK_FOR_US: 'feedback-for-us',
  FEEDBACK_FOR_YOU: 'feedback-for-you',
  SIGN_OFF: 'sign-off',
};

export const Subsections = {
  REVIEW_DIAGNOSIS: 'review-diagnosis',
  REVIEW_MEDICATIONS: 'review-medications',
  UPCOMING_APPOINTMENTS: 'upcoming-appointments',
  DETECTED_CASE_NOTES: 'detected-case-notes',
  REVIEW_CPT_CODES: 'review-cpt-codes',
  // DETECTED_SOCIAL_DETERMINANTS: 'detected-social-determinants',
  // DETECTED_COGNITIVE_ISSUES: 'detected-cognitive-issues',
  REPORT_CARD: 'report-card',
};

export const feedbackForUsSection = [
  Subsections.REVIEW_MEDICATIONS,
  Subsections.UPCOMING_APPOINTMENTS,
];

export const feedbackForYouSection = [
  Subsections.DETECTED_CASE_NOTES,
  Subsections.REPORT_CARD,
];

export const billingRequirementsSection = [
  Subsections.REVIEW_DIAGNOSIS,
  Subsections.REVIEW_CPT_CODES,
];

export const MEMBER_ACTIONS = {
  PROFILE: 'profile',
  AMA: 'ama',
  SCHEDULE: 'schedule',
  CHAT: 'chat',
};
